<template>
  <section class="brochure-page-hero" :class="{ 'brochure-page-hero--home': variant === 'home' }">
    <div class="brochure-page-hero__glow"></div>
    <div
      class="brochure-page-hero__inner"
      :class="{
        'brochure-page-hero__inner--home': variant === 'home',
        'brochure-page-hero__inner--wide': variant === 'wide',
      }"
    >
      <div class="brochure-page-hero__content">
        <nav v-if="breadcrumbs?.length" class="breadcrumb" aria-label="面包屑">
          <template v-for="(crumb, idx) in breadcrumbs" :key="idx">
            <router-link v-if="crumb.to" :to="crumb.to">{{ crumb.label }}</router-link>
            <span v-else>{{ crumb.label }}</span>
            <span v-if="idx < breadcrumbs.length - 1">/</span>
          </template>
        </nav>
        <div v-if="ribbon" class="brochure-page-hero__ribbon">
          <span class="brochure-page-hero__ribbon-dot"></span>
          <span>{{ ribbon }}</span>
        </div>
        <h1 class="brochure-page-hero__title">{{ title }}</h1>
        <p v-if="subtitle" class="brochure-page-hero__sub">{{ subtitle }}</p>
        <ul v-if="tags.length" class="brochure-page-hero__tags">
          <li v-for="tag in tags" :key="tag" class="brochure-page-hero__tag">{{ tag }}</li>
        </ul>
        <div v-if="$slots.actions" class="brochure-page-hero__actions">
          <slot name="actions"></slot>
        </div>
      </div>
      <div v-if="badgeValue !== '' && badgeValue != null" class="brochure-page-hero__badge">
        <span class="brochure-page-hero__badge-num">{{ badgeValue }}</span>
        <span class="brochure-page-hero__badge-label">{{ badgeLabel }}</span>
      </div>
      <slot name="aside"></slot>
    </div>
  </section>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  ribbon: { type: String, default: '' },
  badgeValue: { type: [String, Number], default: '' },
  badgeLabel: { type: String, default: '' },
  tags: { type: Array, default: () => [] },
  breadcrumbs: { type: Array, default: () => [] },
  variant: { type: String, default: 'default' },
})
</script>
